/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Snap_To_Event_Ends_FailedInputs */



/**
* | output |
* | --- |
* | "Snap to event ends failed with message: {error}" |
*
* @param {Snap_To_Event_Ends_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_ends_failed = /** @type {((inputs: Snap_To_Event_Ends_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Ends_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Alignement sur la fin des événements échoué : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Snap to event ends failed with message: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'operazione di aggancio all'evento non è riuscita con il messaggio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сбой привязки к событию завершился с сообщением: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El ajuste al evento finaliza con el mensaje: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`捕捉到事件结束失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント終了へのスナップが失敗し、次のメッセージが表示されました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्नैप टू इवेंट विफल हो गया, संदेश के साथ: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A transição para o evento terminou com a mensagem: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Snap to event ends failed with message: ${i?.error}`)
});